import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValueDTO } from '@ms/core';
import { DateRange } from 'app/layout/components/content/calendar/calendar-event.model';
import { PeriodFee } from 'app/main/shared/model/period-fee.model';
import { Observable } from 'rxjs';
import { ActiveAcademicPeriodTermsInfoDTO, IAcademicPeriod } from '../academic-period-tree/model/academic-period.model';
import { logRequest } from '../shared/http-utils';
import { MessageDTO } from '../shared/model/message.model';

@Injectable({ providedIn: 'root' })
export class AcademicPeriodService {
    baseUrl = '/school-service/api/academic-periods';

    constructor(private http: HttpClient) {}

    getAllAcademicPeriods(schoolId: string): Observable<IAcademicPeriod[]> {
        return this.http.get<IAcademicPeriod[]>(`/school-service/api/school/${schoolId}/academic-periods`);
    }

    getAcademicPeriodById(id: string): Observable<HttpResponse<IAcademicPeriod>> {
        return this.http.get<IAcademicPeriod>(`${this.baseUrl}/${id}`, { observe: 'response' });
    }

    getActiveAcademicPeriod(id: string): Observable<HttpResponse<IAcademicPeriod>> {
        return this.http.get<IAcademicPeriod>(`${this.baseUrl}/active/${id}`, { observe: 'response' });
    }

    createAcademicPeriod(acadPeriod: IAcademicPeriod): Observable<HttpResponse<IAcademicPeriod>> {
        return this.http.post<IAcademicPeriod>(this.baseUrl, acadPeriod, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    updateAcademicPeriod(acadPeriod: IAcademicPeriod): Observable<HttpResponse<IAcademicPeriod>> {
        return this.http.put<IAcademicPeriod>(this.baseUrl, acadPeriod, { observe: 'response', headers: logRequest() });
    }

    deleteAcademicPeriod(id: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${id}`, { observe: 'response', headers: logRequest() });
    }

    getPeriodFeesBySearch(academicPeriodId: string, studentId: string): Observable<HttpResponse<PeriodFee[]>> {
        const search = { academicPeriodId, studentId };
        return this.http.post<PeriodFee[]>(`${this.baseUrl}/period-fees/search`, search, { observe: 'response' });
    }

    getAllForSelectionList(schoolId: string): Observable<KeyValueDTO<DateRange>[]> {
        return this.http.get<KeyValueDTO<DateRange>[]>(`${this.baseUrl}/school/${schoolId}`);
    }

    getAllForSelectionListWithDateRange(schoolId: string): Observable<KeyValueDTO<DateRange>[]> {
        return this.http.get<KeyValueDTO<DateRange>[]>(`${this.baseUrl}/date-range/school/${schoolId}`);
    }

    testDiscountFormula(formula: string): Observable<HttpResponse<MessageDTO>> {
        return this.http.post<MessageDTO>(`${this.baseUrl}/school/discount-formula-test`, formula, {
            observe: 'response',
        });
    }

    getCurrentTermInfoBySchoolId(schoolId: string): Observable<ActiveAcademicPeriodTermsInfoDTO> {
        return this.http.get<ActiveAcademicPeriodTermsInfoDTO>(`${this.baseUrl}/current-term-info/${schoolId}`);
    }

    getAcademicYearTermInfo(academicYearId: string): Observable<ActiveAcademicPeriodTermsInfoDTO> {
        return this.http.get<ActiveAcademicPeriodTermsInfoDTO>(
            `${this.baseUrl}/academic-year-term-info/${academicYearId}`
        );
    }
    getAllAcademicPeriodsWithTermInfo(schoolId: string): Observable<ActiveAcademicPeriodTermsInfoDTO[]> {
        return this.http.get<ActiveAcademicPeriodTermsInfoDTO[]>(
            `${this.baseUrl}/all-academic-year-term-info/${schoolId}`
        );
    }
}
